import React from "react";
import PendingButton from "@p1s/p1s-common-react/PendingButton";
import Button from "@p1s/p1s-common-react/Button";
import PropTypes from "prop-types";
import TextInput from "../../../controls/TextInput";
import { passwordsMatch, passwordValidation } from "../../validation/AccountValidations";
import PasswordValidationSettings from "../../../entities/PasswordValidationSettings";
import { isEnterPressed } from "newApp/utilities/EventsHelper";
import PasswordRequirements from "./PasswordRequirements";
import ServerError from "../../common/ServerError";
import PasswordValidationUserData from "../../../entities/PasswordValidationUserData";

export class PasswordForm extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            password: "",
            repeatPassword: "",
            validationError: "",
            repeatValidationError: ""
        };

        this.onPasswordChange = this.onPasswordChange.bind(this);
        this.onRepeatPasswordChange = this.onRepeatPasswordChange.bind(this);
        this.onEnter = this.onEnter.bind(this);
        this.onComplete = this.onComplete.bind(this);
    }

    onPasswordChange(e) {
        if (e && e.target) {
            var password = e.target.value;
            const validationResult = passwordValidation(password, this.props.passwordRequirements, this.props.passwordValidationUserData);
            const passwordsMatchResult = passwordsMatch(password, this.state.repeatPassword);

            let validationError = undefined;
            let repeatValidationError = validationError;
            if (!validationResult.isValid)
                validationError = validationResult.error;
            else if (!passwordsMatchResult.isValid) {
                repeatValidationError = passwordsMatchResult.error;
            }
            this.setState({
                validationError: validationError,
                repeatValidationError: repeatValidationError,
                password: password
            });
        }
    }

    onRepeatPasswordChange(e) {
        if (e && e.target) {
            var repeatedPassword = e.target.value;
            const passwordsMatchResult = passwordsMatch(this.state.password, repeatedPassword);

            let repeatValidationError = undefined;
            if (!passwordsMatchResult.isValid) {
                repeatValidationError = passwordsMatchResult.error;
            }
            this.setState({ repeatPassword: repeatedPassword, repeatValidationError: repeatValidationError });
        }
    }

    onEnter(e) {
        if (isEnterPressed(e))
            this.onComplete();
    }

    onComplete() {
        const validationResult = passwordValidation(this.state.password, this.props.passwordRequirements, this.props.passwordValidationUserData);
        const passwordsMatchResult = passwordsMatch(this.state.password, this.state.repeatPassword);
        let validationError = undefined;
        let repeatValidationError = validationError;
        if (validationResult.isValid && passwordsMatchResult.isValid) {
            this.props.onComplete(this.state.password);
        } else if (!validationResult.isValid)
            validationError = validationResult.error;
        else if (!passwordsMatchResult.isValid) {
            repeatValidationError = passwordsMatchResult.error;
        }

        this.setState({ validationError: validationError, repeatValidationError: repeatValidationError });
    }

    render() {
        const serverError = this.props.serverError;
        const errorSummary = this.props.errorSummary;
        const validationError = this.state.validationError;
        const repeatValidationError = this.state.repeatValidationError;
        const passwordRequirements = this.props.passwordRequirements ? this.props.passwordRequirements : new PasswordValidationSettings();

        const hasServerError = serverError != null && serverError.length > 0;
        const hasValidationError = validationError != null && validationError.length > 0;

        return (<div name="passwordForm">
            <div className="input-row enter-password">
                <TextInput placeholder="Enter Password"
                    name="password"
                    value={this.state.password}
                    onKeyUp={this.onEnter}
                    onChange={this.onPasswordChange}
                    inputClassName="picker-hollow"
                    isPassword={true}
                    secureTextEntry={true}
                    error={validationError}/>
                <PasswordRequirements passwordRequirements={passwordRequirements}/>
            </div>
            <div className="input-row">
                <TextInput placeholder="Re-Enter Password"
                    name="repeatPassword"
                    value={this.state.repeatPassword}
                    onKeyUp={this.onEnter}
                    onChange={this.onRepeatPasswordChange}
                    inputClassName="picker-hollow"
                    isPassword={true}
                    secureTextEntry={true}
                    error={repeatValidationError}/>
            </div>
            <div className="button-container">
                <PendingButton
                    name="btnCompletePassword"
                    className="btn btn-primary-action pull-right"
                    onClick={this.onComplete}
                    isPending={this.props.isPasswordSetting}
                    title={this.props.buttonText}
                    pendingTitle={""}
                />
            </div>
            <ServerError
                errorSummary={errorSummary}
                serverError={serverError}
                isVisible={hasServerError && !hasValidationError}/>
        </div>);
    }
}

PasswordForm.propTypes = {
    buttonText: PropTypes.string,
    onComplete: PropTypes.func,
    passwordValidationUserData: PropTypes.instanceOf(PasswordValidationUserData),
    passwordRequirements: PropTypes.instanceOf(PasswordValidationSettings),
    serverError: PropTypes.string,
    errorSummary: PropTypes.string,
    isPasswordSetting: PropTypes.bool
};

export default PasswordForm;
